import { useState } from "react";
import { Popover, Badge, Flex } from "antd";
import { SketchPicker } from "react-color";

const ColorPicker = ({ title, icon, onChange }) => {
  const [hex, setHex] = useState("#fff");

  const handleColorChange = (color) => {
    setHex(color.hex);
    onChange(color.hex);
  };

  const content = <SketchPicker color={hex} onChange={handleColorChange} />;

  return (
    <Popover content={content} title={title} trigger="click">
      <Flex style={{ height: 16 }}>
        <Badge dot style={{ backgroundColor: hex }}>
          {icon}
        </Badge>
      </Flex>
    </Popover>
  );
};

export default ColorPicker;
